import React from 'react';
import { withStyles, Button } from '@material-ui/core';
import { Refresh } from '@material-ui/icons';

const styles = (theme) => ({
  mapError: {
    color: theme.errorTextColor,
    padding: '10px',
    fontWeight: 600,
    backgroundColor: theme.errorBGColorSecondary,
    height: '30px',
    fontSize: '14px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  retryButton: {
    height: '30px',
    fontSize: '14px'
  },
  errorContainer: {
    width: '100%',
    height: '100%'
  }
});

const MapErrorFallback = ({ classes, onRetry }) => {
  return (
    <div className={classes.errorContainer}>
      <div className={classes.mapError}>
        Error loading map. Please reload page.
        <Button
          variant="outlined"
          color="inherit"
          size="small"
          onClick={onRetry}
          className={classes.retryButton}
          startIcon={<Refresh color="inherit" />}>
          Refresh
        </Button>
      </div>
    </div>
  );
};

export default withStyles(styles)(MapErrorFallback);
